"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAlignment = void 0;
// eslint-disable-next-line import/prefer-default-export
var TextAlignment;
(function (TextAlignment) {
    TextAlignment["LEFT"] = "left";
    TextAlignment["CENTER"] = "center";
    TextAlignment["RIGHT"] = "right";
})(TextAlignment || (exports.TextAlignment = TextAlignment = {}));
//# sourceMappingURL=enums.js.map